import { useEffect, useReducer } from 'react';

import { FETCH_REDUCER_TYPE } from './const';

const handlers = {
  [FETCH_REDUCER_TYPE.INIT]: ({ state }) => ({
    ...state,
    isLoading: true,
  }),
  [FETCH_REDUCER_TYPE.SUCCESS]: ({ state, payload }) => ({
    ...state,
    isLoading: false,
    error: null,
    data: payload,
  }),
  [FETCH_REDUCER_TYPE.FAILURE]: ({ state, payload }) => ({
    ...state,
    isLoading: false,
    error: payload,
    data: null,
  }),
};

const fetchStateReducer = (state, action) => {
  const { type, payload } = action;
  const currentHandler = handlers[type];

  if (!currentHandler) return state;

  return currentHandler({ state, payload });
};

export const useQuery = (queryCallback, options = { dataMapper: null }) => {
  const { dataMapper } = options;

  const [state, dispatch] = useReducer(fetchStateReducer, {
    isLoading: false,
    error: null,
    data: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: FETCH_REDUCER_TYPE.INIT });

      try {
        const { data } = await queryCallback();

        dispatch({
          type: FETCH_REDUCER_TYPE.SUCCESS,
          payload: dataMapper ? dataMapper(data) : data,
        });
      } catch (error) {
        dispatch({ type: FETCH_REDUCER_TYPE.FAILURE, payload: error });
      }
    };

    fetchData();
  }, []);

  return state;
};
